async function ipLookup() {
    try {
        // const response = await fetch("https://extreme-ip-lookup.com/json/?key=kaBb8sGKq8xxfkZYSEfo");
        // const response = await fetch("https://ipwho.is/");
        const response = await fetch("https://free.freeipapi.com/api/json");
        if (!response.ok) return;
        const json = await response.json();

        let country = "";

        if (typeof json.countryName === "string") {
            country = json.countryName.trim();

            if (country.length > 64) {
                country = "";
            }
        }

        if (country) {
            document.querySelectorAll(".country-estimate").forEach(el => {
                el.value = country;
            });
        }
    } catch (error) {
        console.warn("IP lookup failed");
    }
}